import videoPlayer from '../../../shared/videoPlayer'
import sceneMove from '../../../shared/videos/sceneMove'

export default () => {
  videoPlayer();
  sceneMove();
};
